export default "__VITE_ASSET__CRQ511LS__"